export const fuseNavigationConfig = [
    {
        
    }
];
